import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getReq, postReq } from "../../configs/ApiUrl.js";
import { useTranslation } from "react-i18next";
import { Tabs, Tab, Paper, Box } from "@mui/material";

import PageHeader from "../PageHeader.js";
import PageFooter from "../PageFooter.js";

import { ReactComponent as History } from "../../icons/History-Icon.svg";
import { ReactComponent as Logout } from "../../icons/Logout-Icon.svg";
import { ReactComponent as Sell } from "../../icons/Coin-Icon-Outline.svg";
import { ReactComponent as Profile } from "../../icons/User-Circle-Icon.svg";

import EditDetails from "./UserContact.js";
import OrderHistory from "../pages/UserBuy";
import SellingHistory from "../pages/UserSell";

function UserProfile() {
  const { t } = useTranslation(["userProfile"]);
  const navigateLogout = useNavigate();
  const [tabIndex, setTabIndex] = useState(0);
  const [userInfo, setUserInfo] = useState(null);

  useEffect(() => {
    const fetchUser = async () => {
      const userId = localStorage.getItem("userId");
      if (!userId) return;
      try {
        const userResp = await getReq(`/user/${userId}`);
        setUserInfo(userResp);
      } catch (e) {
        console.error(e);
      }
    };
    fetchUser();
  }, []);

  const handleLogOut = async () => {
    const logOutResp = await postReq("/user/logout");
    if (logOutResp?.success) {
      localStorage.removeItem("token");
      localStorage.removeItem("userId");
      navigateLogout("/welcome-login");
    }
  };

  const tabs = [
    {
      label: t("contactInfoButton"),
      icon: <Profile className='mr-1' />,
      component: <EditDetails />,
    },
    {
      label: t("approvedDeliveryButton"),
      icon: <Sell className='mr-1' />,
      component: <SellingHistory />,
    },
    {
      label: t("productsBoughtButton"),
      icon: <History className='mr-1' />,
      component: <OrderHistory />,
    },
    {
      label: t("logoutButton"),
      icon: <Logout className='mr-1 text-red-500' />,
      logout: true,
    },
  ];

  const handleTabChange = (e, newValue) => {
    const selectedTab = tabs[newValue];
    if (selectedTab.logout) {
      handleLogOut();
      return;
    }
    setTabIndex(newValue);
  };

  return (
    <div className='flex flex-col min-h-screen'>
      <PageHeader />

      <section className='flex flex-col flex-1 pt-10'>
        <Paper
          elevation={0}
          className='rounded-lg overflow-hidden'
          sx={{
            bgcolor: "#ffffff",
            p: 2,
          }}>
          <Tabs
            value={tabIndex}
            onChange={handleTabChange}
            variant='scrollable'
            scrollButtons='auto'
            className='bg-white shadow-md border-b mt-4'
            TabIndicatorProps={{ style: { backgroundColor: "#6366F1" } }}>
            {tabs.map((tab, idx) => (
              <Tab
                key={idx}
                icon={tab.icon}
                iconPosition='start'
                label={
                  <span
                    className={`capitalize text-sm font-medium ${
                      tab.logout ? "text-red-500" : ""
                    }`}>
                    {tab.label}
                  </span>
                }
                className={`normal-case px-4 ${
                  tab.logout ? "text-red-500" : ""
                }`}
              />
            ))}
          </Tabs>

          <Box className='p-4 bg-gray-50 min-h-[60vh]'>
            {tabs.map((tab, idx) => (
              <div
                key={idx}
                hidden={tabIndex !== idx}
                className='w-full'>
                {!tab.logout && tabIndex === idx && tab.component}
              </div>
            ))}
          </Box>
        </Paper>
      </section>

      <Box
        sx={{ mb: 2 }}
        className='block md:hidden'>
        <PageFooter />
      </Box>
    </div>
  );
}

export default UserProfile;
